<template>
  <div ref="chart" class="chart" />
</template>

<script>
import config from '../../config'
import { jsonp } from '../../utils/request'
import createChart from './chart.js'

export default {
  name: 'TheChart',
  props: {
    code: String,
    isRise: Boolean,
  },
  methods: {},
  mounted () {
    const chart = createChart({
      color: this.isRise ? [0, 199, 86] : [242, 74, 58],
      container: this.$refs.chart,
    })
    jsonp(config.server.api + '/api/web/quotation/kChart/jsonp', {
      type: 10,
      excode: 'EX',
      code: this.code,
    }).then(res => {
      chart.setData(res.reverse())
    })
  },
}
</script>

<style scoped lang="scss">
.chart {
  width: 120px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/TheChart.vue